import jwt_decode from 'jwt-decode';
import store from 'store2';
import reduxStore from 'packages/store';
import * as types from 'packages/store/types';
import { ActiveSplits } from 'packages/store/user/types';

class AuthenticationHelper {
    getToken = (): string => {
        const state = reduxStore.getState();
        const kongTreatment = state.user.splitFeatures?.[ActiveSplits.studioKongGateway];

        return kongTreatment === 'on' ? state.platform.bynderAccessToken : state.platform.accessToken;
    };

    setToken = async (token: string): Promise<void> => {
        await reduxStore.dispatch({
            type: types.UPDATE_PLATFORM_OPTIONS,
            options: {
                accessToken: token,
            },
        });
    };

    // TODO: This a big problem since token not always in place. Better to resolve it via BE
    getProfiles = () => {
        if (!this.getToken()) {
            return [];
        }

        const decoded = jwt_decode(this.getToken()) as any;

        return decoded && decoded.bynderProfileId ? decoded.bynderProfileId : [];
    };

    isLoggedIn = (): boolean => {
        const token = store.get('accessToken');

        return !!token;
    };
}

export default new AuthenticationHelper();
